//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { SocialNetwork } from '@models/SocialNetwork';
import { getReachTooltipContentCaveat } from '@utils/social-text-utils/socialTextUtils';

export const COMMENTS_TABLE_HEADER = 'Cmts.';
export const ENGAGEMENT_TABLE_HEADER = 'Eng. Rate';
export const IMPRESSIONS_TABLE_HEADER = 'Impr.';
export const LIKES_TABLE_HEADER = 'Likes';
export const POSTED_TIMESTAMP_TABLE_HEADER = 'Posted Date';
export const REACH_TABLE_HEADER = 'Reach';
export const SAVES_TABLE_HEADER = 'Saves';
export const VIDEO_VIEWS_TABLE_HEADER = 'Vid. Views';
export const VIEWS_TABLE_HEADER = 'Views';
export const SHARE_COUNT_TABLE_HEADER = 'Shares';

export const ORGANIC_METRIC_LABEL_NOTE =
  'This metric only includes organic traffic.';

export const COMMENTS_TOOLTIP = `Number of comments left on this post. ${ORGANIC_METRIC_LABEL_NOTE}`;
export const ENGAGEMENT_TOOLTIP = `Engagement rate is calculated as the sum of likes, comments, saves, and shares divided by the reach for this post. ${ORGANIC_METRIC_LABEL_NOTE}`;
export const LIKES_TOOLTIP = `Number of times this post has been liked. ${ORGANIC_METRIC_LABEL_NOTE}`;
export const REACH_TOOLTIP = `Number of unique users who have seen this post. ${ORGANIC_METRIC_LABEL_NOTE} ${getReachTooltipContentCaveat(
  SocialNetwork.Instagram,
)}`;
export const SAVES_TOOLTIP = `Number of times this post has been saved. ${ORGANIC_METRIC_LABEL_NOTE}`;
export const VIDEO_VIEWS_TOOLTIP = `Number of times a video has played. ${ORGANIC_METRIC_LABEL_NOTE}`;
export const VIEWS_TOOLTIP = `Number of times a post has been viewed. ${ORGANIC_METRIC_LABEL_NOTE}`;
export const SHARE_COUNT_TOOLTIP = `Number of times this post has been shared. ${ORGANIC_METRIC_LABEL_NOTE}`;

export const LIST_VIEW_SQUARE_IMAGE_SIZE = 100;
export const LIST_VIEW_COPYRIGHTED_PLACEHOLDER_TYPE = 'condensed';

export const TABLE_ACTION_BUTTONS_WIDTH = 64;
